export interface RankDefinition {
  readonly name: string;
  readonly colorHex: string; // e.g. #00FF66
  readonly min: number; // inclusive
  readonly max?: number; // inclusive; if omitted, treated as Infinity
}

export const RANKS: readonly RankDefinition[] = [
    // ---- LOSS ZONE (< $1000) ----
    { name: "Rugpulled Rookie",      colorHex: "#6B6B6B", min: 0,   max: 49 },
    { name: "Liquidation Lunch",     colorHex: "#707070", min: 50,  max: 149 },
    { name: "Exit Liquidity",        colorHex: "#756B63", min: 150, max: 249 },
    { name: "Bagholder",             colorHex: "#7A6E5E", min: 250, max: 399 },
    { name: "Paper Hands",           colorHex: "#8A6F6F", min: 400, max: 549 },
    { name: "Dip Worshipper",        colorHex: "#8E7A6A", min: 550, max: 699 },
    { name: "Bear Market Camper",    colorHex: "#8A5F5F", min: 700, max: 849 },
    { name: "Margin Call Magnet",    colorHex: "#9A6A6A", min: 850, max: 999 },
  
    // ---- WIN ZONE (>= $1000) with accelerating gaps ----
    { name: "HODL Novice",           colorHex: "#A6C8FF", min: 1000, max: 1120 },
    { name: "Bull Cub",              colorHex: "#86B6FF", min: 1121, max: 1272 },
    { name: "Green Candle Chaser",   colorHex: "#70E070", min: 1273, max: 1464 },
    { name: "Breakout Believer",     colorHex: "#63E6A5", min: 1465, max: 1707 },
    { name: "FOMO Knight",           colorHex: "#4ED9C0", min: 1708, max: 2015 },
    { name: "Altcoin Adventurer",    colorHex: "#3FB0FF", min: 2016, max: 2409 },
    { name: "Dip Slayer",            colorHex: "#57E3FF", min: 2410, max: 2916 },
    { name: "Moon Ticket Holder",    colorHex: "#FFD166", min: 2917, max: 3573 },
    { name: "Pump Prophet",          colorHex: "#FFC300", min: 3574, max: 4432 },
    { name: "Chart Whisperer",       colorHex: "#DA70D6", min: 4433, max: 5563 },
    { name: "Diamond Hands",         colorHex: "#FF69B4", min: 5564, max: 7052 },
    { name: "Lambo Lurker",          colorHex: "#B19CD9", min: 7053, max: 9019 },
    { name: "DeFi Dabbler",          colorHex: "#6FE7C8", min: 9020, max: 11652 },
    { name: "Token Tycoon",          colorHex: "#E6B800", min: 11653, max: 15154 },
    { name: "Liquidity Lord",        colorHex: "#FF8C00", min: 15155, max: 19782 },
    { name: "Ape Alliance",          colorHex: "#F77FBE", min: 19783, max: 25918 },
    { name: "Shillmaster General",   colorHex: "#FF5E5E", min: 25919, max: 33942 },
    { name: "Whale Watcher",         colorHex: "#57D6FF", min: 33943, max: 44479 },
    { name: "Orca Operator",         colorHex: "#49E6A6", min: 44480, max: 58363 },
    { name: "Mega Whale",            colorHex: "#FF5EA8", min: 58364, max: 76763 },
    { name: "Kraken Cartel",         colorHex: "#7AD7FF", min: 76764, max: 101904 },
    { name: "Meme Coin Emperor",     colorHex: "#FF6F3D", min: 101905, max: 135482 },
    { name: "Lunar Overlord",        colorHex: "#C071FF", min: 135483, max: 181853 },
    { name: "Rocket Fueler",         colorHex: "#FFE45E", min: 181854, max: 244565 },
    { name: "Galaxy Trader",         colorHex: "#67F0FF", min: 244566, max: 328807 },
    { name: "Nebula Navigator",      colorHex: "#9CF27C", min: 328808, max: 442346 },
    { name: "Interstellar Speculator",colorHex: "#FF99CC", min: 442347, max: 596617 },
    { name: "Cosmic Market Maker",   colorHex: "#7BE7FF", min: 596618, max: 805989 },
    { name: "Warp-Speed Whale",      colorHex: "#7FFF9F", min: 805990, max: 1_087_986 },
    { name: "Multichain Monarch",    colorHex: "#FFD36E", min: 1_087_987, max: 1_468_301 },
    { name: "On-Chain Overlord",     colorHex: "#62D0FF", min: 1_468_302, max: 1_976_091 },
    { name: "Protocol Baron",        colorHex: "#9AF28F", min: 1_976_092, max: 2_669_732 },
    { name: "Yield Yakuza",          colorHex: "#FF8AB0", min: 2_669_733, max: 3_631_621 },
    { name: "Airdrop Archduke",      colorHex: "#6FE6FF", min: 3_631_622, max: 4_979_689 },
    { name: "Gasless Godhand",       colorHex: "#B0FF72", min: 4_979_690, max: 6_886_064 },
    { name: "Alpha Oracle",          colorHex: "#F5A623", min: 6_886_065, max: 9_713_492 },
    { name: "Sigma Sniper",          colorHex: "#7EC8FF", min: 9_713_493, max: 13_871_443 },
    { name: "Volatility Virtuoso",   colorHex: "#9BFF9B", min: 13_871_444, max: 19_919_533 },
    { name: "Candlestick Sorcerer",  colorHex: "#FF7F7F", min: 19_919_534, max: 28_996_313 },
    { name: "Liquidity Dragon",      colorHex: "#7FF1FF", min: 28_996_314, max: 42_042_655 },
    { name: "Treasury Titan",        colorHex: "#FEE440", min: 42_042_656, max: 61_676_412 },
    { name: "Token Sultan",          colorHex: "#C77DFF", min: 61_676_413, max: 91_901_991 },
    { name: "Vault Viceroy",         colorHex: "#5BE8B0", min: 91_901_992, max: 138_587_987 },
    { name: "Governance Godmode",    colorHex: "#FFA552", min: 138_587_988, max: 211_223_182 },
    { name: "Sovereign Whale",       colorHex: "#8AC8FF", min: 211_223_183, max: 326_387_936 },
    { name: "Metagalactic Magnate",  colorHex: "#7CFFB5", min: 326_387_937, max: 514_901_291 },
    { name: "Infinite Printer Max",  colorHex: "#FFD700", min: 514_901_292, max: 815_092_003 },
    { name: "Legend of the Ledger",  colorHex: "#9D7CFF", min: 815_092_004, max: 1_220_788_006 },
    { name: "Ω-Class Market Maker",  colorHex: "#00E5FF", min: 1_220_788_007, max: 1_809_788_010 },
    { name: "Eternal Bull Emperor",  colorHex: "#00FFA3", min: 1_809_788_011, max: 2_209_116_546 },
    { name: "Cosmos-Scale Cartel",   colorHex: "#FF6A00", min: 2_209_116_547 } // open-ended top rank
  ] as const;
  

export function getRankForDollars(amount: number): RankDefinition {
  for (const rank of RANKS) {
    const withinMin = amount >= rank.min;
    const withinMax = rank.max === undefined ? true : amount <= rank.max;
    if (withinMin && withinMax) return rank;
  }
  return RANKS[0];
}
